export default __webpack_public_path__ + "static/media/joshua-earlesz.5351084e.jpg";